export default __webpack_public_path__ + "static/media/fffLogo.e106ad55.png";